import {rawRenderingLib} from '@wallaby-ui/core';

import {dashboardEncounterLinkFormatterFunction} from './dashboard_encounter_link_formatter';
import styles from 'src/js/common/components/formatters/CasePatientHospitalizationFormatter.less';
import baseCasePatientAGFormatterParams from 'src/js/lib/raw_rendering/base_case_patient_ag_formatter_params';

/**
 * Returns raw DOM element version of CasePatientAGFormatter component.
 * @param params
 * @param services
 * @returns {Element|String}
 */
export default function casePatientAGFormatter(params, services = {}) {
  const {caseId, formattedValue, hasLink, newData, style, value} =
    baseCasePatientAGFormatterParams(params, services);

  let divElem;
  if (value) {
    divElem = document.createElement('div');
    divElem.className = styles.dlCasePatientHospitalizationFormatter;
    rawRenderingLib.RawRenderingService.setNodeStyle(divElem, style);

    let childElem;
    if (caseId && hasLink) {
      childElem = document.createElement('span');
      childElem.className = styles.dlEncounterTypeParentWrapper;

      const spanElem = document.createElement('span');
      spanElem.className = styles.dlEncounterTypeParent;

      const linkElem = dashboardEncounterLinkFormatterFunction(
        {...params, data: newData, value: formattedValue},
        services
      );

      rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
        spanElem,
        linkElem
      );
      rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
        childElem,
        spanElem
      );
    } else {
      childElem = `<span>${formattedValue}</span>`;
    }

    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      divElem,
      childElem
    );
  } else {
    divElem = '';
  }

  return divElem;
}
